// Sarrdeh: the icon set is cached for a year, so the URLs carry its version
// (keep in step with the ?v= on the favicon links in vueapp.html.erb).
const ICON_VERSION = 'v=3';

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/brand/favicon-badge-${favicon.sizes[[0]]}.png?${ICON_VERSION}`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/brand/favicon-${favicon.sizes[[0]]}.png?${ICON_VERSION}`;
        favicon.href = oldFileName;
      });
    }
  });
};
